angular
  .module('contributor')

  .factory('EducationCrud', [
    'Crud',

    function(Crud) {
      'use strict';

      class EducationCrud extends Crud {
        constructor(list) {
          super(
            'education' + (list || ''),
            '@@apiUrl' + '/educations' + (list || '') + '/:id',
            { id: '@id' },
            {
              query: {
                method: 'GET',
                isArray: true
              }
            }
          );
        }
      }

      return EducationCrud;
    }
  ]);
